import { CircleCheck, CircleX, TriangleAlert } from 'lucide-react'
import type { SegregationStatus } from '@/types'

export const SEGREGATION_OPTIONS: Array<{
  value: SegregationStatus
  label: string
  selectedClassName: string
  icon: typeof CircleCheck
}> = [
  {
    value: 'good',
    label: 'Bueno',
    selectedClassName: 'border-green-600 bg-green-50 text-green-700',
    icon: CircleCheck,
  },
  {
    value: 'regular',
    label: 'Regular',
    selectedClassName: 'border-amber-500 bg-amber-50 text-amber-700',
    icon: TriangleAlert,
  },
  {
    value: 'bad',
    label: 'Malo',
    selectedClassName: 'border-red-500 bg-red-50 text-red-700',
    icon: CircleX,
  },
]

export function getSegregationOption(status: SegregationStatus | '') {
  return SEGREGATION_OPTIONS.find((option) => option.value === status) ?? null
}
